/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { clientTicketControllerCancel } from '../fn/client-ticket/client-ticket-controller-cancel';
import { ClientTicketControllerCancel$Params } from '../fn/client-ticket/client-ticket-controller-cancel';
import { clientTicketControllerCreate } from '../fn/client-ticket/client-ticket-controller-create';
import { ClientTicketControllerCreate$Params } from '../fn/client-ticket/client-ticket-controller-create';
import { clientTicketControllerDelete } from '../fn/client-ticket/client-ticket-controller-delete';
import { ClientTicketControllerDelete$Params } from '../fn/client-ticket/client-ticket-controller-delete';
import { clientTicketControllerFindAll } from '../fn/client-ticket/client-ticket-controller-find-all';
import { ClientTicketControllerFindAll$Params } from '../fn/client-ticket/client-ticket-controller-find-all';
import { clientTicketControllerFindById } from '../fn/client-ticket/client-ticket-controller-find-by-id';
import { ClientTicketControllerFindById$Params } from '../fn/client-ticket/client-ticket-controller-find-by-id';
import { clientTicketControllerSearchCursor } from '../fn/client-ticket/client-ticket-controller-search-cursor';
import { ClientTicketControllerSearchCursor$Params } from '../fn/client-ticket/client-ticket-controller-search-cursor';
import { clientTicketControllerSearchOffset } from '../fn/client-ticket/client-ticket-controller-search-offset';
import { ClientTicketControllerSearchOffset$Params } from '../fn/client-ticket/client-ticket-controller-search-offset';
import { ClientTicketDto } from '../models/client-ticket-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ClientTicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientTicketControllerFindAll()` */
  static readonly ClientTicketControllerFindAllPath = '/api/client-ticket';

  /**
   * 고객사 이용권 전체 조회.
   *
   * 고객사 이용권 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerFindAll$Response(params?: ClientTicketControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientTicketDto>>> {
    return clientTicketControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 전체 조회.
   *
   * 고객사 이용권 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerFindAll(params?: ClientTicketControllerFindAll$Params, context?: HttpContext): Observable<Array<ClientTicketDto>> {
    return this.clientTicketControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientTicketDto>>): Array<ClientTicketDto> => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerSearchOffset()` */
  static readonly ClientTicketControllerSearchOffsetPath = '/api/client-ticket/search/offset';

  /**
   * 고객사 이용권 오프셋 기반 조회.
   *
   * 고객사 이용권을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerSearchOffset$Response(params: ClientTicketControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return clientTicketControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 오프셋 기반 조회.
   *
   * 고객사 이용권을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerSearchOffset(params: ClientTicketControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.clientTicketControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerSearchCursor()` */
  static readonly ClientTicketControllerSearchCursorPath = '/api/client-ticket/search/cursor';

  /**
   * 고객사 이용권 커서 기반 조회.
   *
   * 고객사 이용권을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerSearchCursor$Response(params: ClientTicketControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return clientTicketControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 커서 기반 조회.
   *
   * 고객사 이용권을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerSearchCursor(params: ClientTicketControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.clientTicketControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerFindById()` */
  static readonly ClientTicketControllerFindByIdPath = '/api/client-ticket/{id}';

  /**
   * 고객사 이용권 ID 기반 조회.
   *
   * 고객사 이용권을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerFindById$Response(params: ClientTicketControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
    return clientTicketControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 ID 기반 조회.
   *
   * 고객사 이용권을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerFindById(params: ClientTicketControllerFindById$Params, context?: HttpContext): Observable<ClientTicketDto> {
    return this.clientTicketControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientTicketDto>): ClientTicketDto => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerDelete()` */
  static readonly ClientTicketControllerDeletePath = '/api/client-ticket/{id}';

  /**
   * 고객사 이용권 삭제.
   *
   * 고객사 이용권을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerDelete$Response(params: ClientTicketControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
    return clientTicketControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 삭제.
   *
   * 고객사 이용권을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  clientTicketControllerDelete(params: ClientTicketControllerDelete$Params, context?: HttpContext): Observable<ClientTicketDto> {
    return this.clientTicketControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientTicketDto>): ClientTicketDto => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerCreate()` */
  static readonly ClientTicketControllerCreatePath = '/api/client-ticket/{clientWorkspaceId}/{vendorWorkspaceId}';

  /**
   * 고객사 이용권 생성.
   *
   * 고객사 이용권을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTicketControllerCreate$Response(params: ClientTicketControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
    return clientTicketControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 생성.
   *
   * 고객사 이용권을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTicketControllerCreate(params: ClientTicketControllerCreate$Params, context?: HttpContext): Observable<ClientTicketDto> {
    return this.clientTicketControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientTicketDto>): ClientTicketDto => r.body)
    );
  }

  /** Path part for operation `clientTicketControllerCancel()` */
  static readonly ClientTicketControllerCancelPath = '/api/client-ticket/{vendorWorkspaceId}/{ticketId}';

  /**
   * 고객사 이용권 취소.
   *
   * 고객사 이용권을 취소합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTicketControllerCancel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTicketControllerCancel$Response(params: ClientTicketControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientTicketDto>> {
    return clientTicketControllerCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 이용권 취소.
   *
   * 고객사 이용권을 취소합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTicketControllerCancel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTicketControllerCancel(params: ClientTicketControllerCancel$Params, context?: HttpContext): Observable<ClientTicketDto> {
    return this.clientTicketControllerCancel$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientTicketDto>): ClientTicketDto => r.body)
    );
  }

}
